import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { zodResponseFormat } from "openai/helpers/zod";
import { useEffect, useMemo, useRef, useState } from "react";
import { Stepper } from "react-form-stepper";
import { MdDownloadDone, MdMic, MdMicOff } from "react-icons/md";
import { TailSpin, ThreeDots } from 'react-loader-spinner';
import { useSearchParams } from "react-router-dom";
import { z } from "zod";
import useApiFetcher from "../../hooks/useApiFetcher";
import { avatarAppConfig } from "../Avatar/config";
import {
  createAvatarSynthesizer,
  createWebRTCConnection
} from "../Avatar/Utility";
import Board from "../f&i_Product/Board";
import Agreement from "./Agreement/Agreement";
import styles from "./Avatar.module.css";
import SelectionLayout from "./SelectionLayout/SelectionLayout";
import TableOne from "./Table/BoardFourA/BoardFourA";
import TableTwo from "./Table/BoardFourB/BoardFourB";
import { SoundWave } from "./SoundWave";
import { BsChatLeftText } from "react-icons/bs";
import Chat from "../Chat/Chat";
import { IoMdMicrophone } from "react-icons/io";


let scriptArr = [];
let unSelectionScript = [];
let reSelectionScript = [];
var isSpeakingEnabled = false;
const priceArr = [];
let introPrompt = []
let productScriptPrompt = [];
let statusArr;
const coreFeature = []
const partialFeature = []
let lastScreen = false
const Avatar = () => {

  
  const user = JSON.parse(localStorage.getItem("user"));
  const [userName, setUserName] = useState("");
  const [userQueriesHistory, setUserQueriesHistory] = useState([]);
  const [dynamicSteps, setDynamicSteps] = useState();
  const [isStepperExpire, setStepperExpire] = useState(false);

  const [searchParams] = useSearchParams();
  const dealId = searchParams.get('deal');
  const userId = searchParams.get('custId');
  const { apiFetcher } = useApiFetcher();
  const [loading, setLoading] = useState(false);
  const [showTranscript , setShowTranscript] = useState(false);
    const [qaHistory, setQaHistory] = useState([]); 



  useEffect(() => {
    if (user?.role === "DealershipAdmin") {
      setUserName(user?.dealershipId?.dealershipName);
    } else {
      setUserName("");
    }
  }, [user]);

  useEffect(() => {

    const trackProgress = async () => {
      setLoading(true)
      try {
        const resp = await apiFetcher('/track-progress', "POST", { userId, deal: dealId, step: 0, totalStep: dynamicSteps?.length })

        if (resp?.completedRounds === 20000) {
          setStepperExpire(true)
          setLoading(false)
        } else {
          setStepperExpire(false)
          setLoading(false)
        }
      } catch (error) {
        console.error("Error fetching script data:", error);
        setLoading(false)
      }

    }
    if (dynamicSteps?.length) {
      trackProgress()
    }
  }, [dynamicSteps]);

  let debounceTimeout;
  const [boardData, setBoardData] = useState([]);
  const [showBoardBtn, setShowBoardBtn] = useState(false)
  const [boardBtnText, setboardBtnText] = useState("")
  const [summaryScreen, setSummaryScreen] = useState(false);


  const [currentIndex, setCurrentIndex] = useState(0);
  const [status, setStatus] = useState([])
  const [labels, setlabels] = useState([])
  const [tempArr, setTempArr] = useState(Array(priceArr.length).fill(0));
  const [totalPrice, setTotalPrice] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState("")
  const [isThinking, setIsThinking] = useState(false)
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [submitBtn, setSubmitBtn] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [backButtonClicked, setBackButtonClicked] = useState(false)
  const handleFocus = () => {
    setIsActive(true);
  };
  const handleBlur = () => {
    setIsActive(false);
  };
  const handleOnSubmit = () => {
    handleUserHistory(submitBtn);
    setSubmitBtn("");
    setIsActive(false);
  };


  const updatePrices = (updatedStatusArr) => {
    // Update tempArr based on updatedStatusArr
    if (apiData) {
      const newTempArr = updatedStatusArr.map((status, index) =>
        status ? priceArr[index] : 0
      );

      // Calculate the total price
      const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);

      function calculatePMT(rate, nper, pv) {
        if (pv === 0) return 0; // If loan amount is zero, no payment needed
        if (nper <= 0) return 0; // Avoid division errors
        if (rate === 0) return pv / nper; // Simple division when rate is zero


        rate = rate / 100;
        const monthlyRate = rate / 12;
        const pmt = (monthlyRate * pv) / (1 - Math.pow(1 + monthlyRate, -nper));
        return pmt;
      }
      const annualInterestRate = Number(`${apiData?.deal.intrestedRate}`);
      const totalPeriods = Number(`${apiData?.deal.financeDuration}`);
      const allSelected = updatedStatusArr.every(status => status === true);
      const summaryStep = apiData?.getScript?.steps.find(
        (step) => step.type === "Summary Script"
      );
      const discountPercentage = Number(summaryStep?.discountPercent ?? 0);
      const discountTotalPayment = allSelected
        ? newTotalPrice * (1 - discountPercentage / 100)
        : newTotalPrice;


      const loanAmount = discountTotalPayment + Number(`${apiData?.deal.financeAmount}`)
      const monthlyPayment = calculatePMT(annualInterestRate, totalPeriods, loanAmount);

      setTempArr(newTempArr);
      setTotalPrice(discountTotalPayment);
      setMonthlyPayment(monthlyPayment)
    }
  };

  const [start, setStart] = useState(true);
  const [index, setIndex] = useState(0);
  const [avatarSynthesizer, setAvatarSynthesizer] = useState(null);
  const [microphoneEnabled, setMicrophoneEnabled] = useState(true);
  var [speechRecognizer, setSpeechRecognizer] = useState(null);
  const [slotLength, setSoltLength] = useState(0);
  const [isDisable, setIsDisable] = useState(true);
  const [showFinalSummaryScreen, setShowFinalSummaryScreen] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [formData, setFormData] = useState(null);
  const [apiData, setApiData] = useState("");
  const [dynamicPrompt, setDynamicPrompt] = useState("")
  const [showTable, setShowTable] = useState(false)
  const [showTableTwo, setShowTableTwo] = useState(false)
   const [mode, setMode] = useState('mic');

  useEffect(() => {
    updatePrices(status, priceArr, 6.45, 72)
  }, [status, showFinalSummaryScreen, summaryScreen])

  useEffect(() => {
    statusArr = [...status];
  }, [status])
  const initializeScript = (script, productPrice) => {
    unSelectionScript = [];
    reSelectionScript = [];
    productScriptPrompt = []
    introPrompt = []
    priceArr.length = 0;
    coreFeature.length = 0
    partialFeature.length = 0
    // priceArr = []
    let labelsArray = [];
    productPrice?.forEach((data) => {
      const productPrice = Number(data.price) || 0;
      const tax = Number(data.tax) || 0;
      console.log("Tax Data", tax)
      const priceWithTax = productPrice + (productPrice * tax / 100);
      priceArr.push(priceWithTax)
      console.log(priceArr, "priceArr")
    })
    script.forEach((step) => {
      if (step.type === "Product Script") {
        unSelectionScript.push(step.unSelection); // For deselection
        reSelectionScript.push(step.reSelection); // For reselection
        labelsArray.push(step.stepTitle)
        productScriptPrompt.push(step.script)
        // priceArr.push(Number(step.price))
        // const priceWithTax = Number(step.price) + (Number(step.price) * (Number(step.priceTax) / 100));

        coreFeature.push(step.corsText)
        partialFeature.push(step.partialText)
        // setlabels((prev) => [...prev, step.stepTitle]);
      }
      if (step.type === "Intro") {
        introPrompt.push(step.script)
      }

    });
    setlabels(labelsArray)
    statusArr = Array(unSelectionScript.length).fill(true);
    const dynamicSteps = script.map((item, idx) => ({
      label: item.stepTitle,
      id: idx,
    }));
    setDynamicSteps(dynamicSteps);
    setStatus(statusArr);
  };



  useEffect(() => {
    if (!window.hasInitialized) {
      const fetchData = async () => {
        const response = await apiFetcher(`/deals/${dealId}/script`);
        const formData = {
          avatar: response.deal.dealershipId.avatar.split(",")[0],
          style: response.deal.dealershipId.avatar.split(",")[1],
          voice: response.deal.dealershipId.voice,
        };
        setApiData(response)
        setFormData(formData);
        setDynamicPrompt(response.getScript.aiPrompt)
        const productPrice = response?.deal.productPrices
        const script = response?.getScript?.steps;

        initializeScript(script, productPrice);
        window.hasInitialized = true;
      };
      fetchData();
    }
  }, []);
  function splitSentences(text) {
    // Regex to match sentence-ending punctuation (., !, ?) followed by spaces
    const sentenceRegex = /([.!?])\s+/g;

    const sentences = [];
    let lastIndex = 0;

    // Iterate over the matches to split sentences
    text.replace(sentenceRegex, (match, punctuation, offset) => {
      // Extract the sentence up to the matched punctuation and trim leading/trailing spaces
      const sentence = text.slice(lastIndex, offset + punctuation.length).trim();

      if (sentence) {
        // If the sentence is shorter than 15 characters, don't split
        if (sentence.length < 15) {
          if (sentences.length > 0) {
            // Add the sentence to the last one (concatenation)
            sentences[sentences.length - 1] += " " + sentence;
          } else {
            sentences.push(sentence);
          }
        } else {
          sentences.push(sentence);
        }
      }
      lastIndex = offset + punctuation.length; // Update the last index for the next slice
      return match;
    });

    const remainingText = text.slice(lastIndex).trim();
    if (remainingText) {
      sentences.push(remainingText);
    }

    return sentences;
  }
  useEffect(() => {
    if (!loading) {
      const fetchData = async () => {
        try {
          const response = await apiFetcher(`/deals/${dealId}/script`);
          const script = response?.getScript?.steps;
          if (!window.hasInitialized) {
            initializeScript(script);
          }
          const currentScript = script[index]?.script || "";
          setCurrentIndex(index);
          if (!backButtonClicked) {
            scriptArr = splitSentences(currentScript);
            apiFetcher('/track-progress', "POST", { userId, deal: dealId, step: index, totalStep: dynamicSteps?.length })
          } else {
            scriptArr = splitSentences("okay I think you clicked back button How can i help you")
          }
          isSpeakingEnabled = true;
          speakSelectedText();
          const summaryScriptAvailable = script.some(step => step.type === "Summary Script");
          if (!summaryScriptAvailable) {
            setIsDisable(false)
          }
          if (script[index]?.type === "Summary Script") {
            setSummaryScreen(true);
            setIsDisable(false)
            scriptArr.push(`your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`)
          }
          if (script[index]?.type === "Final Script") {
            setShowFinalSummaryScreen(true)
            lastScreen = true
          }
        } catch (error) {
          console.error("Error fetching script data:", error);
        }
      };
      fetchData();
    }
  }, [loading, index]);

  const myAvatarVideoEleRef = useRef();
  const myAvatarAudioEleRef = useRef();
  const myAvatarCanvasRef = useRef(null);
  const disconnectRef = useRef();
  const iceUrl = avatarAppConfig.iceUrl;
  const iceUsername = avatarAppConfig.iceUsername;
  const iceCredential = avatarAppConfig.iceCredential;
  const cogSvcRegion = avatarAppConfig.cogSvcRegion;
  const cogSvcSubKey = avatarAppConfig.cogSvcSubKey;
  const geminiAPIKey = process.env.REACT_APP_GEMINI_API_KEY || avatarAppConfig.geminiAPIKey;
  const sarvamAPIKey = avatarAppConfig.sarvamAPIKey;
  useEffect(() => {
    const onBeforeUnload = (e) => handleWindowClose(e, apiData, start);

    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [apiData, start]);

  const startSession = () => {
    setLoading(true);
    const peerConnection = createWebRTCConnection(
      iceUrl,
      iceUsername,
      iceCredential
    );
    peerConnection.ontrack = handleOnTrack;
    peerConnection.addTransceiver("video", { direction: "sendrecv" });
    peerConnection.addTransceiver("audio", { direction: "sendrecv" });

    const avatarSynth = createAvatarSynthesizer(formData); // Pass formData
    setAvatarSynthesizer(avatarSynth);

    peerConnection.oniceconnectionstatechange = (e) => {
      console.log("WebRTC status: " + peerConnection.iceConnectionState);
      if (peerConnection.iceConnectionState === "connected") {
        console.log("Connected to Azure Avatar service");
      }
      if (
        peerConnection.iceConnectionState === "disconnected" ||
        peerConnection.iceConnectionState === "failed"
      ) {
        console.log("Azure Avatar service Disconnected");
        // window.location.reload();
      }
    };

    avatarSynth
      .startAvatarAsync(peerConnection)
      .then(() => {
        console.log("Avatar started.");
        const timer = setTimeout(() => {
          setLoading(false);
          setStart(false);
        }, 3000);
      })
      .catch((error) => {
        console.log("Avatar failed to start. Error: " + error);
        setLoading(false); // Ensure loading stops even on failure
        // window.location.reload();
      });

    const speechRecognitionConfig = SpeechSDK.SpeechConfig.fromEndpoint(
      new URL(
        `wss://${cogSvcRegion}.stt.speech.microsoft.com/speech/universal/v2`
      ),
      cogSvcSubKey
    );
    speechRecognitionConfig.setProperty(
      SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode,
      "Continuous"
    );
    const sttLocales = ["en-US", "de-DE", "es-ES"];
    const autoDetectSourceLanguageConfig =
      SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(sttLocales);
    const speechRecog = SpeechSDK.SpeechRecognizer.FromConfig(
      speechRecognitionConfig,
      autoDetectSourceLanguageConfig,
      SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
    );
    setSpeechRecognizer(speechRecog);



  };
  const handleStepperClick = (e) => {
    // if (isSpeaking) {
    //   console.log("Cannot proceed. Avatar is speaking.");
    //   return; // Exit if the avatar is currently speaking
    // }

    if (isSpeaking && !isListening && !isThinking) {
      const clickedStep = parseInt(e.target.innerText, 10);
      if (clickedStep === 1 || clickedStep === 2 || clickedStep === 3 || clickedStep === 4 || clickedStep === 5) {
        setBackButtonClicked(false)
      }
      setSummaryScreen(false)
      setShowFinalSummaryScreen(false)
      lastScreen = false
      scriptArr = []
      setIndex(clickedStep - 1)
    }

  }

  const handleOnTrack = (event) => {
    if (event.track.kind === "video") {
      const mediaPlayer = myAvatarVideoEleRef.current;
      mediaPlayer.id = event.track.kind;
      mediaPlayer.srcObject = event.streams[0];
      mediaPlayer.autoplay = true;
      mediaPlayer.playsInline = true;
      mediaPlayer.addEventListener("play", () => {
        window.requestAnimationFrame(() => { });
      });
    } else {
      const audioPlayer = myAvatarAudioEleRef.current;
      audioPlayer.srcObject = event.streams[0];
      audioPlayer.autoplay = true;
      audioPlayer.playsInline = true;
      audioPlayer.muted = true;
    }
  };

  const statusArraySchema = z.array(z.boolean());
  const responseSchema = z.object({
    answer: z.string(),
    array: statusArraySchema,
  });
function storeQA(question, answer) {
    setQaHistory(prev => [...prev, { question, answer }]);
  }
  const handleUserHistory = async (userQuery) => {
    setIsThinking(true)
    setUserQueriesHistory((prevHistory) => [...prevHistory, { question: userQuery, answer: null }]);
    const slot_prompt = `
${introPrompt
        .map((step) => `Intro: ${step.script || "No script provided"}`)
        .join("\n")}
        You are an assistant managing a list of service packages for a customer. The customer previously discussed the following services, with an initial selection status as follows:
  
     Loan Amount:-${apiData.deal.financeAmount}
     Annual Interest Rate:-${apiData.deal.intrestedRate}
Loan Tenure (in years):-${apiData.deal.financeDuration}
        ${productScriptPrompt
        .map((step, index) => `${labels[index]} : ${step}`)
        .join("\n")}
  
        The customer’s initial selection status is represented by an array:
        ${JSON.stringify(status)}, where each position corresponds to a service:
       ${labels
        .map(
          (step, index) => `- Position ${index}: ${labels[index]}  -- initial selection status : ${status[index]}`
        )
        .join("\n")}
  
        Instructions:
        ${dynamicPrompt}
        
        **** IMPORTANT NOTE****
        ONLY USE WHEN USER ASK ABOUT ANY EMI CALCULATION EMI Calculation Instructions: To calculate your monthly EMI (Equated Monthly Installment), use the following formula: EMI = (P * r * (1 + r)^n) / ((1 + r)^n - 1), where P is the loan amount, r is the monthly interest rate, and n is the number of months. tell me only answer don't tell formula if interest rate is not available take 7 % also tell user interest rate all other value they tell answer.
        Updated status array reflecting any changes, with each position as true or false
        **NOTE **  
         - This Data only use when some one ask about any this from this data ${JSON.stringify(apiData.deal, null, 2)}  and Monthly Price is ${monthlyPayment}
         - Give Answer in 2 to 4 line only if user ask tell me in detail or ask in brif then give in brif
          *** This is Question and its Answer previously discussed with the customer, so you can use this information to answer the current question. *** 
         -${qaHistory.map((qa) => `Question: ${qa.question} Answer: ${qa.answer}`).join("\n")}
          }
        `;
    const isQuestionInquiry = /\b(what is|what's|whats|what are|explain|tell me about|how does|what does|why do|why should|why would|info on|details on|meaning of|definition|is it worth|should i get|do i need|describe|how much|\?)\b/i.test(userQuery);

    // API Request Setup with Google Gemini AI
    const activeKey = geminiAPIKey || sarvamAPIKey;
    const isGemini = !!geminiAPIKey;
    const bodyPayload = {
      model: isGemini ? "gemini-2.5-flash" : "sarvam-105b",
      messages: [
        { role: "system", content: slot_prompt + "\n\nYou MUST respond ONLY with a valid JSON object. The JSON object must have exactly two properties: \"answer\" (a string with your verbal response) and \"array\" (an array of booleans representing the selection status of the items). If the user is merely asking a question or for explanation, DO NOT modify the selection status array—keep each boolean exactly as provided in the initial selection status array! Do not include any markdown formatting, backticks, or any other text." },
        { role: "user", content: userQuery },
      ],
      max_tokens: 400,
      temperature: 0.3
    };

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${activeKey}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(bodyPayload),
      redirect: "follow",
    };

    try {
      const endpoint = isGemini
        ? "https://generativelanguage.googleapis.com/v1beta/openai/chat/completions"
        : "https://api.sarvam.ai/v1/chat/completions";

      const response = await fetch(endpoint, requestOptions);

      const data = await response.json();
      let parsedResponse = data.choices?.[0]?.message?.content || "";
      console.log("Raw Response:", parsedResponse);
      
      // Strip markdown backticks if the model added them anyway
      parsedResponse = parsedResponse.replace(/```json/gi, "").replace(/```/g, "").trim();
      
      let answer, updatedStatusArr;
      try {
          const parsed = JSON.parse(parsedResponse);
          answer = parsed.answer;
          updatedStatusArr = parsed.array;
      } catch (e) {
          console.warn("AI returned text instead of JSON. Falling back to plain text answer.");
          updatedStatusArr = statusArr; // Fallback to original array
          
          // Try to rescue the answer if it was just truncated JSON
          const answerMatch = parsedResponse.match(/"answer"\s*:\s*"([^]*?)"(?:(?=\s*,)|(?=\s*\}))/);
          if (answerMatch && answerMatch[1]) {
              answer = answerMatch[1];
          } else {
              // Clean out the JSON garbage and the array part so Aimee doesn't speak it aloud
              answer = parsedResponse
                  .replace(/```json/gi, "")
                  .replace(/```/g, "")
                  .replace(/"array"\s*:\s*\[.*?\]/g, "") // Remove array if complete
                  .replace(/"array"\s*:\s*\[.*/g, "") // Remove array if truncated
                  .replace(/[{}]/g, "")
                  .replace(/"answer"\s*:/gi, "")
                  .replace(/"/g, "")
                  .replace(/true/gi, "")
                  .replace(/false/gi, "")
                  .trim();
          }
      }

      // If user was asking a question/inquiry or array is invalid, strictly protect existing selection!
      if (isQuestionInquiry || !Array.isArray(updatedStatusArr) || updatedStatusArr.length !== statusArr.length) {
        updatedStatusArr = statusArr;
      }
         storeQA(userQuery, answer);
      setIsThinking(false)
      setUserQueriesHistory((prevHistory) => {
        const updatedHistory = [...prevHistory];
        updatedHistory[updatedHistory.length - 1].answer = answer;
        return updatedHistory;
      });
      for (let index = 0; index < updatedStatusArr.length; index++) {
        const status = updatedStatusArr[index];
        if (status !== statusArr[index]) {
          if (status) {
            await updatePrices(updatedStatusArr); // Wait for updatePrices to finish
            isSpeakingEnabled = true;
            statusArr = [...updatedStatusArr];
            setStatus(updatedStatusArr);
            const newTempArr = updatedStatusArr.map((status, i) => (status ? priceArr[i] : 0));
            const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
            function calculatePMT(rate, nper, pv) {
              if (pv === 0) return 0; // If loan amount is zero, no payment needed
              if (nper <= 0) return 0; // Avoid division errors
              if (rate === 0) return pv / nper; // Simple division when rate is zero
              rate = rate / 100;
              const monthlyRate = rate / 12;
              const pmt = (monthlyRate * pv) / (1 - Math.pow(1 + monthlyRate, -nper));
              return pmt;
            }
            const annualInterestRate = Number(`${apiData?.deal.intrestedRate}`);
            const totalPeriods = Number(`${apiData?.deal.financeDuration}`);
            const allSelected = updatedStatusArr.every(status => status === true);
            // const summaryStep = apiData?.getScript?.steps.find(
            //   (step) => step.stepTitle === "Summary" || step.stepTitle === "Bundle"
            // );

            //use a valid identifier like type instead of stepTitle as each client can enter diferenet titles for summary like bundle or summary 
            const summaryStep = apiData?.getScript?.steps.find(
              (step) => step.type === "Summary Script"
            );
            const discountPercentage = Number(summaryStep?.discountPercent);
            const discountTotalPayment = allSelected
              ? newTotalPrice * (1 - discountPercentage / 100)
              : newTotalPrice;
            const loanAmount = discountTotalPayment + Number(`${apiData?.deal.financeAmount}`)
            const monthlyPayment = calculatePMT(annualInterestRate, totalPeriods, loanAmount);
            const reSelectionScriptandTotal = `${reSelectionScript[index]}  your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`;
            speakSelectedText(reSelectionScriptandTotal);
            return;
          } else {
            console.log("ARR UN ", unSelectionScript[index]);
            await updatePrices(updatedStatusArr); // Wait for updatePrices to finish
            isSpeakingEnabled = true;
            statusArr = [...updatedStatusArr];
            setStatus(updatedStatusArr);
            const newTempArr = updatedStatusArr.map((status, i) => (status ? priceArr[i] : 0));
            const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
            function calculatePMT(rate, nper, pv) {
              if (pv === 0) return 0; // If loan amount is zero, no payment needed
              if (nper <= 0) return 0; // Avoid division errors
              if (rate === 0) return pv / nper; // Simple division when rate is zero
              rate = rate / 100;
              const monthlyRate = rate / 12;
              const pmt = (monthlyRate * pv) / (1 - Math.pow(1 + monthlyRate, -nper));
              return pmt;
            }
            const annualInterestRate = Number(`${apiData?.deal.intrestedRate}`);
            const totalPeriods = Number(`${apiData?.deal.financeDuration}`);
            const allSelected = updatedStatusArr.every(status => status === true);
            // const summaryStep = apiData?.getScript?.steps.find(
            //   (step) => step.stepTitle === "Summary" || step.stepTitle === "Bundle"
            // );

            //use a valid identifier like type instead of stepTitle as each client can enter diferenet titles for summary like bundle or summary 
            const summaryStep = apiData?.getScript?.steps.find(
              (step) => step.type === "Summary Script"
            );
            const discountPercentage = Number(summaryStep.discountPercent);
            const discountTotalPayment = allSelected
              ? newTotalPrice * (1 - discountPercentage / 100)
              : newTotalPrice;
            const loanAmount = discountTotalPayment + Number(`${apiData?.deal.financeAmount}`)
            const monthlyPayment = calculatePMT(annualInterestRate, totalPeriods, loanAmount);
            const unSelectionScriptandTotal = `${unSelectionScript[index]}  your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`;
            console.log("SSS", unSelectionScriptandTotal);
            speakSelectedText(unSelectionScriptandTotal);
            return;
          }
        }
      }

      // Update Status Array
      isSpeakingEnabled = true;
      speakSelectedText(answer);
      statusArr = [...updatedStatusArr];
      setStatus(updatedStatusArr)
      updatePrices(updatedStatusArr);

      // Speak the Model's Main Answer

    } catch (error) {
      console.error("Error fetching or parsing response:", error);
    }
  };

  // handleUserHistory("what is service contract")
  const stopSession = () => {
    if (avatarSynthesizer) {
      avatarSynthesizer
        .stopSpeakingAsync()
        .then(() => {
          avatarSynthesizer.close();
        })
        .catch((error) => {
          console.log("Error stopping session", error);
        });
    }
  };
  let count = 0

  const sendEmailToDealerAdmin = async () => {
    const products = labels.map((label, index) => ({
      id: index,
      name: label,
      isSelected: status[index],
      price: priceArr[index],
    }));
    const selectedProducts = products.filter((product) => product.isSelected);
    const unselectedProducts = products.filter((product) => !product.isSelected);
    const summaryStep = apiData?.getScript?.steps.find(
      (step) => step.type === "Summary Script"
    );
    const discountPercentage = Number(summaryStep?.discountPercent);
    const selectedTotalPrice = selectedProducts.reduce(
      (acc, product) => acc + product.price,
      0
    );
    const allSelected = status.every(array => array === true);
    const discountTotalPayment = allSelected
      ? selectedTotalPrice * (1 - discountPercentage / 100)
      : selectedTotalPrice;
    const agreementData = {
      customerName: apiData?.deal.custId.customerName,
      selectedProducts: selectedProducts.map((product) => ({
        name: product.name,
        price: product.price,
      })),
      unselectedProducts: unselectedProducts.map((product) => ({
        name: product.name,
        price: product.price,
      })),
      totalPrice: discountTotalPayment,
      loanAmount: apiData?.deal.financeAmount,
      monthlyPayment: monthlyPayment.toFixed(2),
      interestRate: apiData?.deal.intrestedRate,
      discountPercentage: discountPercentage,
      allSelected,
      deal: apiData?.deal,
    };
    try {
      await apiFetcher("/multi-stepper/send-email-to-dealeradmin", "POST", {
        userQueriesHistory,
        agreementData,
        dealerEmail: apiData?.dealerEmail
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const sanitizeText = (text) => {
    return text?.trim().replace(/[^\w\s]/g, "").toLowerCase() || "";
  };

  const checkLastSentence = (finaltextToSpeak, lastSentence) => {
    const sanitizedFinalText = sanitizeText(finaltextToSpeak)
    const sanitizedLastSentence = sanitizeText(lastSentence)

    const isLastSentence = sanitizedFinalText === sanitizedLastSentence
    // Check if the last sentence is being spoken
    return isLastSentence;
  }

  const notepadMap = useMemo(() => {
    const notepadContents = apiData?.getScript?.steps?.[index]?.notepadContents;
    const map = new Map();
    if (notepadContents && typeof notepadContents === "object") {
      for (const key in notepadContents) {
        const sanitizedKey = sanitizeText(key)
        map.set(sanitizedKey, notepadContents[key]);
      }
      return map;
    }
    return map;
  }, [index, apiData]); // Runs only when index or apiData changes

  const speakSelectedText = (query) => {
    setIsSpeaking(false);
    const audioPlayer = myAvatarAudioEleRef.current || {};
    audioPlayer["muted"] = false;
    let finaltextToSpeak = "";
    const lastSentence = scriptArr?.[scriptArr.length - 1] || "";//it will give us the last sentence in script

    if (!isSpeakingEnabled) {
      return;
    }
    if (apiData?.getScript?.steps[index]?.type === "Intro") {
      count = count + 1;
      if (count === 4) {
        console.log("SHOW TABLE ONE")
        setShowTable(true)
      }
      if (count === 4) {
        setTimeout(() => {
          setShowTableTwo(true)
        }, 3500)

      }
      if (count === 5) {
        setShowTable(false)
      }
    }
    if (!query) {
      finaltextToSpeak = scriptArr.shift();
    } else {
      finaltextToSpeak = query;
    }

    if (finaltextToSpeak === undefined) {
      return;
    }

    //check if its the last sentence being spoken by Aimee and show the button then
    const buttonText = apiData?.getScript?.steps?.[index]?.buttonText
    const isLastSentence = checkLastSentence(finaltextToSpeak, lastSentence);
    if (isLastSentence) {
      setShowBoardBtn(true)
      setboardBtnText(buttonText)
    }

    //this code is to show relevant notepad data on screen when aimee speaks corresponding sentence
    const sanitizedfinaltextToSpeak = sanitizeText(finaltextToSpeak)
    if (notepadMap.has(sanitizedfinaltextToSpeak)) {
      const matchedNotepadData = notepadMap.get(sanitizedfinaltextToSpeak);
      setBoardData(matchedNotepadData);
    }

    if (finaltextToSpeak && avatarSynthesizer) {
      avatarSynthesizer
        .speakTextAsync(finaltextToSpeak)
        .then(async (result) => {
          if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
            if (scriptArr.length > 0) {
              speakSelectedText();
            } else {
              // If no more sentences, trigger any final actions
              setIsSpeaking(true);
              if (lastScreen && userQueriesHistory?.length) {
                await sendEmailToDealerAdmin()

              }
              if (lastScreen) {
                apiFetcher('/track-progress', "POST", { userId, deal: dealId, step: dynamicSteps?.length, totalStep: dynamicSteps?.length })
              }
            }
          } else {
            console.log("Unable to speak. Result ID: " + result.resultId);
            if (result.reason === SpeechSDK.ResultReason.Canceled) {
              const cancellationDetails = SpeechSDK.SpeakerAudioDestination.CancellationDetails.fromResult(result);
              console.log("Canceled. Reason: " + cancellationDetails.reason);
              if (cancellationDetails.reason === SpeechSDK.CancellationReason.Error) {
                console.log("Error details: " + cancellationDetails.errorDetails);
              }
            }
          }
        })
        .catch((err) => {
          console.error("Error in speakTextAsync:", err);
        });
    } else if (finaltextToSpeak && !avatarSynthesizer) {
        console.warn("Avatar synthesizer is not initialized yet. Skipping speech.");
    } else {
      if (index === slotLength - 1) {
        console.log("SHOW SUMMARY");
      }
    }
  };


  // const speakSelectedText = (query) => {
  //   setIsSpeaking(false);
  //   const audioPlayer = myAvatarAudioEleRef.current || {};
  //   audioPlayer["muted"] = false;
  //   let finaltextToSpeak = "";
  //   const lastSentence = scriptArr?.[scriptArr.length - 1];//it will give us the last sentence in script
  //   console.log(lastSentence, 'lastsentence')

  //   if (!isSpeakingEnabled) {
  //     return;
  //   }
  //   if (apiData.getScript.steps[index].type === "Intro") {
  //     count = count + 1;
  //     console.log("count++", count)
  //     if (count === 4) {
  //       console.log("SHOW TABLE ONE")
  //       setShowTable(true)
  //     }
  //     if (count === 4) {
  //       setTimeout(() => {
  //         setShowTableTwo(true)
  //       }, 3500)

  //     }
  //     if (count === 5) {
  //       setShowTable(false)
  //     }
  //   }
  //   if (!query) {
  //     finaltextToSpeak = scriptArr.shift();
  //   } else {
  //     finaltextToSpeak = query;
  //   }

  //   if (finaltextToSpeak === undefined) {
  //     return;
  //   }

  //   const notepadContents = apiData?.getScript?.steps?.[index]?.notepadContents;
  //   console.log(notepadContents, 'notepadContents')
  //   const buttonText = apiData?.getScript?.steps?.[index]?.buttonText

  //   if (notepadContents && typeof notepadContents === "object") {
  //     // let isLastSentence = false;

  //     const sanitizedFinalText = finaltextToSpeak.trim().replace(/[^\w\s]/g, "").toLowerCase();
  //     const sanitizedLastSentence = lastSentence?.trim()?.replace(/[^\w\s]/g, "").toLowerCase();
  //     // Check if the last sentence is being spoken
  //     if (sanitizedFinalText === sanitizedLastSentence) {
  //       console.log(sanitizedLastSentence, 'found our match in last sentence')
  //       // isLastSentence = true;
  //       setShowBoardBtn(true)
  //       setboardBtnText(buttonText)
  //     }
  //     // Loop through the object
  //     for (const key in notepadContents) {
  //       console.log("key", key);

  //       const sanitizedfinaltextToSpeak = finaltextToSpeak
  //         .trim()
  //         .replace(/[^\w\s]/g, "")
  //         .toLowerCase(); // Normalize case for comparison
  //       const sanitizedkey = key
  //         .trim()
  //         .replace(/[^\w\s]/g, "")
  //         .toLowerCase(); // Normalize case for comparison

  //       const isTextIncluded = sanitizedfinaltextToSpeak.includes(sanitizedkey);
  //       console.log("isTextIncluded", isTextIncluded);

  //       if (isTextIncluded) {
  //         console.log("Found matching key in notepad:", key);
  //         console.log("Notepad Object:", notepadContents[key]);

  //         // Update board data
  //         setBoardData(notepadContents[key]);
  //         // setBoardData({
  //         //   ...notepadContents[key],
  //         //   buttonText: isLastSentence && buttonText
  //         // });

  //         // Debugging: Check if button is set
  //         if (notepadContents[key].isButton) {
  //           console.log("Button is set to true for this key.");
  //         }

  //         break;
  //       }
  //     }
  //   } else {
  //     console.log("notepadContents is not valid or is not an object.");
  //   }

  //   if (finaltextToSpeak) {
  //     avatarSynthesizer
  //       .speakTextAsync(finaltextToSpeak)
  //       .then((result) => {
  //         if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
  //           console.log("Speech and avatar synthesized to video stream.");
  //           console.log("Avatar has finished speaking.");
  //           if (scriptArr.length > 0) {
  //             speakSelectedText();
  //           } else {
  //             // If no more sentences, trigger any final actions
  //             setIsSpeaking(true);
  //             const sendEmailToDealerAdmin = async () => {
  //               const products = labels.map((label, index) => ({
  //                 id: index,
  //                 name: label,
  //                 isSelected: status[index],
  //                 price: priceArr[index],
  //               }));
  //               const selectedProducts = products.filter((product) => product.isSelected);
  //               const unselectedProducts = products.filter((product) => !product.isSelected);
  //               const summaryStep = apiData?.getScript?.steps.find(
  //                 (step) => step.type === "Summary Script"
  //               );
  //               const discountPercentage = Number(summaryStep?.discountPercent);
  //               const selectedTotalPrice = selectedProducts.reduce(
  //                 (acc, product) => acc + product.price,
  //                 0
  //               );
  //               const allSelected = status.every(array => array === true);
  //               const discountTotalPayment = allSelected
  //                 ? selectedTotalPrice * (1 - discountPercentage / 100)
  //                 : selectedTotalPrice;
  //               const agreementData = {
  //                 customerName: apiData?.deal.custId.customerName,
  //                 selectedProducts: selectedProducts.map((product) => ({
  //                   name: product.name,
  //                   price: product.price,
  //                 })),
  //                 unselectedProducts: unselectedProducts.map((product) => ({
  //                   name: product.name,
  //                   price: product.price,
  //                 })),
  //                 totalPrice: discountTotalPayment,
  //                 loanAmount: apiData?.deal.financeAmount,
  //                 monthlyPayment: monthlyPayment.toFixed(2),
  //                 interestRate: apiData?.deal.intrestedRate,
  //                 discountPercentage: discountPercentage,
  //                 allSelected,
  //                 deal: apiData?.deal,
  //               };
  //               try {
  //                 await apiFetcher("/multi-stepper/send-email-to-dealeradmin", "POST", {
  //                   userQueriesHistory,
  //                   agreementData,
  //                   dealerEmail: apiData?.dealerEmail
  //                 });
  //               } catch (error) {
  //                 console.error('Error:', error);
  //               }
  //             };

  //             if (lastScreen && userQueriesHistory?.length) {
  //               sendEmailToDealerAdmin()
  //             }
  //           }
  //         } else {
  //           console.log("Unable to speak. Result ID: " + result.resultId);
  //           if (result.reason === SpeechSDK.ResultReason.Canceled) {
  //             const cancellationDetails =
  //               SpeechSDK.CancellationDetails.fromResult(result);
  //             console.log(cancellationDetails.reason);
  //             if (
  //               cancellationDetails.reason === SpeechSDK.CancellationReason.Error
  //             ) {
  //               console.log(cancellationDetails.errorDetails);
  //             }
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         avatarSynthesizer.close();
  //       });
  //   } else {
  //     console.log("empty finaltextToSpeak");
  //     if (index === slotLength - 1) {
  //       console.log("SHOW SUMMARY");
  //     }
  //   }
  // };

  const applyChromaKeyEffect = () => {
    const video = myAvatarVideoEleRef.current;
    const canvas = myAvatarCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const chromaKey = () => {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const frame = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = frame.data;

      const greenThreshold = {
        rMin: 0,
        rMax: 100,
        gMin: 100,
        gMax: 255,
        bMin: 0,
        bMax: 100,
      };
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        if (
          r >= greenThreshold.rMin &&
          r <= greenThreshold.rMax &&
          g >= greenThreshold.gMin &&
          g <= greenThreshold.gMax &&
          b >= greenThreshold.bMin &&
          b <= greenThreshold.bMax
        ) {
          data[i + 3] = 0; // Set alpha to 0 for transparency
        }
      }

      ctx.putImageData(frame, 0, 0);
      requestAnimationFrame(chromaKey);
    };

    video.addEventListener("play", () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      chromaKey();
    });
  };

  const handleWindowClose = async (event, apiData) => {
    event.preventDefault();

    if (apiData?.deal?.custId && Object.keys(apiData?.deal?.custId)?.length && !start) {
      const resp = await apiFetcher('/track-progress', "POST", { userId, deal: dealId, step: dynamicSteps?.length, totalStep: dynamicSteps?.length })
      const agreementData = {
        custId: apiData?.deal?.custId,
      };
      await apiFetcher("/track-progress/close-stepper", "POST", {
        userQueriesHistory,
        step: index,
        agreementData,
        dealerEmail: apiData?.dealerEmail
      });
    }
    if (disconnectRef.current) {
      console.log("DIS");
      disconnectRef.current.click();
    }
  };

  const microphone = async (e) => {

    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!isSpeaking) return
    isSpeakingEnabled = false;

    avatarSynthesizer
      .stopSpeakingAsync()
      .then(() => {
        setIsListening(true);
        console.log(
          "[" + new Date().toISOString() + "] Stop speaking request sent."
        );
      })
      .catch();
    speechRecognizer.recognized = async (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        let userQuery = e.result.text.trim();
        // speakSelectedText()
        if (userQuery === "") {
          return;
        }
        handleUserHistory(userQuery);

        const continuousConversation = false;
        if (!continuousConversation) {
          setMicrophoneEnabled(false);
          speechRecognizer.stopContinuousRecognitionAsync(
            () => {
              setMicrophoneEnabled(true);
              setIsListening(false);
            },
            (err) => {
              console.log("Failed to stop continuous recognition:", err);
              setMicrophoneEnabled(true);
            }
          );
        }
      }
    };

    speechRecognizer.startContinuousRecognitionAsync(
      () => {
        setMicrophoneEnabled(true);
      },
      (err) => {
        console.log("Failed to start continuous recognition:", err);
        setMicrophoneEnabled(true);
      }
    );
  };
  const stopMicrophone = async () => {
    try {
      console.log("Stopping microphone...");
      setIsListening(false);
      setMicrophoneEnabled(true);
      await avatarSynthesizer.stopSpeakingAsync();
      console.log("Avatar stopped speaking.");

      speechRecognizer.stopContinuousRecognitionAsync(
        () => {
          console.log("Speech recognition stopped.");
          setMicrophoneEnabled(true);
        },
        (err) => {
          console.error("Failed to stop continuous recognition:", err);
        }
      );
    } catch (error) {
      console.error("Error while stopping the microphone:", error);
    }
  };
  const handleMicClick = (action) => {
    clearTimeout(debounceTimeout); // Clear previous debounce timer
    debounceTimeout = setTimeout(() => {
      if (action === "start") {
        microphone();
      } else if (action === "stop") {
        stopMicrophone();
      }
    }, 500); // Adjust debounce delay as needed
  };

  return (
    <>{
      apiData ?
        <div className={styles.mainAvatarContainer}>

          <div className={styles.notpadmain}>
            <div className={styles.myAvatarDemoText}>{userName.charAt(0).toUpperCase() + userName.slice(1)} Finance Representative: Aimee</div>
            <div>
              <Stepper
                steps={dynamicSteps}
                activeStep={currentIndex}
                className={styles.stepperStep}
                onClick={(e) => handleStepperClick(e)}

                styleConfig={{
                  activeBgColor: "#3b82f6",
                  completedBgColor: "#8b5cf6",
                  inactiveBgColor: "#e2e8f0",
                  activeTextColor: "#ffffff",
                  completedTextColor: "#ffffff",
                  inactiveTextColor: "#475569",
                }}
              />
              <div className={styles.newContainer}>
                <div className={styles.Avatar}>
                  <div className={styles.container}>
                    <div className={styles.videoContainer}>
                      {start ? (
                        <div className={styles.loading}>

                          {loading ? (
                            <div className={styles.loader}></div>
                          ) : isStepperExpire ? <>

                            <div className={styles.loadingcontainer}>
                              <div className={styles.welcomeBox}>
                                <>
                                  <h1 className={styles.greeting}>
                                    This link has expired.
                                  </h1>
                                  <p className={styles.intro}>
                                    Please contact {apiData?.deal?.dealershipId?.dealershipName} Admin to request a new access link.
                                  </p>
                                </>
                              </div>
                            </div>
                          </> : (
                            <>
                              <div className={styles.loadingcontainer}>
                                <div className={styles.welcomeBox}>
                                  {`${apiData?.deal?.custId?.email}` === "abc@gmail.com" ?
                                    <>
                                      <h1 className={styles.greeting}>
                                        I want to work for you, {apiData?.deal?.dealershipId?.dealershipName}
                                      </h1>
                                    </>
                                    :
                                    <>
                                      <h1 className={styles.greeting}>Welcome, {apiData?.deal?.custId?.customerName}!</h1>
                                      <p className={styles.intro}>
                                        Your Loan is APPROVED with {userName.charAt(0).toUpperCase() + userName.slice(1)} Financial Services, let's review your options.{' '}
                                      </p>
                                    </>

                                  }
                                  {apiData && <button className={styles.startButton} onClick={startSession}>
                                    Start Now
                                  </button>}
                                </div>
                              </div>
                            </>
                          )
                          }
                        </div>
                      ) : (
                        null
                      )}

                      <div className={styles.videoDiv}>
                        <video
                          className="myAvatarVideoElement"
                          ref={myAvatarVideoEleRef}
                          onLoadedData={applyChromaKeyEffect}
                          style={{ display: "none" }}
                        />
                        <audio ref={myAvatarAudioEleRef} />
                        <canvas ref={myAvatarCanvasRef} className={styles.myAvatarCanvas} />
                      </div>
                    </div>
                    {showTranscript ? (<Chat />) : null}
                    <div className={styles.btnContainer}>

                      <>

                        {isThinking ?
                          <>
                            <div className={styles.thinkingLoader}>
                              <ThreeDots
                                visible={true}
                                height="40"
                                width="40"
                                color="#fff"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            </div>
                          </>
                          :
                          <>
                            {/* <div className={styles.btnContainer}> */}

                            {mode === "mic" ?
                              (

                                <button
                                  disabled={!isSpeaking}
                                  className={styles.btns}
                                  onClick={() => setMode('text')}
                                  title="Switch to Text"
                                >
                                  <BsChatLeftText />
                                </button>
                              ) :
                              (
                                <button
                                  disabled={!isSpeaking}
                                  className={styles.btns}
                                  onClick={() => setMode('mic')}
                                  title="Switch to mic"
                                >

                                  <IoMdMicrophone />
                                </button>
                              )
                            }
                            {isListening ? (
                              <SoundWave />
                            ) : mode === 'text' ? (
                              <textarea
                                className="styledTextarea"
                                placeholder="Type here..."
                                onFocus={handleFocus}
                                onBlur={handleBlur}

                                disabled={false}
                                onChange={(e) => {
                                  console.log("Textarea input:", e.target.value);
                                  setSubmitBtn(e.target.value);
                                }}
                                value={submitBtn}
                              ></textarea>
                            ) : (
                              <SoundWave />
                            )}

                            {/* {!isSpeaking || isListening ? (
                              <textarea
                                className="styledTextarea"
                                placeholder="Type here..."
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                disabled={true}
                                onChange={(e) => {
                                  console.log("Textarea input:", e.target.value);
                                  setSubmitBtn(e.target.value);
                                }}
                                value={submitBtn}

                              ></textarea>

                            ) :
                              (
                                <textarea
                                  className="styledTextarea"
                                  placeholder="Type here..."
                                  onFocus={handleFocus}
                                  onBlur={handleBlur}
                                  disabled={isDisable}
                                  onChange={(e) => {
                                    console.log("Textarea input:", e.target.value);
                                    setSubmitBtn(e.target.value);
                                  }}
                                  value={submitBtn}

                                ></textarea>
                              )} */}

                            {isActive ?
                              (
                                <button
                                  disabled={!isSpeaking}
                                  className={styles.btns}
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={handleOnSubmit}
                                >
                                  <MdDownloadDone />
                                </button>
                              ) :
                              (
                                <>
                                  {mode === 'mic' ? (
                                    <div className={styles.btnWrapper}>
                                      <button disabled={isDisable} className={`${isListening ? styles.micDisable : styles.mic}`}>
                                        {isListening ? (
                                          <MdMicOff onClick={() => handleMicClick("stop")} title="Turn off mic" />
                                        ) : (
                                          <MdMic onClick={() => handleMicClick("start")} title="Turn on mic" />
                                        )}
                                      </button> </div>

                                  ) : (null)}
                                </>
                              )}
                            {/* </div> */}
                          </>
                        }
                      </>
                    </div>
                  </div>
                  <div>
                    <button
                      ref={disconnectRef}
                      className={styles.btn}
                      onClick={stopSession}
                      style={{ "display": "none" }}
                    >
                      {" "}
                      Disconnect{" "}
                    </button>
                  </div>
                </div>
                <div className={styles.Board}>
                  {!showFinalSummaryScreen ?
                    <>
                      {summaryScreen ? (
                        <SelectionLayout setBackButtonClicked={setBackButtonClicked} isSpeaking={isSpeaking} isThinking={isThinking} isListening={isListening} apiData={apiData} priceArr={priceArr} coreFeature={coreFeature} partialFeature={partialFeature} index={index} setIndex={setIndex} labels={labels} status={status} setStatus={setStatus} speakSelectedText={speakSelectedText} unSelectionScript={unSelectionScript} reSelectionScript={reSelectionScript} scriptArr={scriptArr} isSpeakingEnabled={isSpeakingEnabled} tempArr={tempArr} totalPrice={totalPrice} monthlyPayment={monthlyPayment} userQueriesHistory={userQueriesHistory} statusArr={statusArr} />
                      ) : (
                        <>{showTable ?
                          <>
                            {!showTableTwo ? <TableOne apiData={apiData} /> : <TableTwo apiData={apiData} />}
                          </>
                          :
                          <Board
                            key={`${boardData?.images}-${boardData?.subHeading}-${boardData?.sentence}`}
                            // isButton={boardData?.isButton}
                            // buttonText={boardData?.buttonText}
                            boardBtnText={boardBtnText}
                            setboardBtnText={setboardBtnText}
                            showBoardBtn={showBoardBtn}
                            setShowBoardBtn={setShowBoardBtn}
                            isSpeaking={isSpeaking}
                            // key={dataArray[currentIndex].id}
                            index={index}
                            setIndex={setIndex}
                            images={boardData?.images}
                            heading={boardData?.heading}
                            subHeading={boardData?.subHeading}
                            mainContent={boardData?.sentence}
                            tableData={apiData?.deal}
                          />
                        }
                        </>
                      )}
                    </> :
                    <>
                      <Agreement isSpeaking={isSpeaking} isThinking={isThinking} isListening={isListening} setIndex={setIndex} setShowFinalSummaryScreen={setShowFinalSummaryScreen} labels={labels} status={status} monthlyPayment={monthlyPayment} totalPrice={totalPrice} priceArr={priceArr} apiData={apiData} userQueriesHistory={userQueriesHistory} lastScreen={lastScreen} setBackButtonClicked={setBackButtonClicked} />
                    </>}
                </div>
              </div>
            </div>
          </div>

        </div >
        :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <TailSpin
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="loading"
          />
        </div>
    }
    </>
  );
};
export default Avatar;
